import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import styles from './ProfileMenu.module.scss';
import ProfileMenuHeader from './ProfileMenuHeader';
import ProfileMenuButton from './ProfileMenuButton';
import ProfileMenuItems from './ProfileMenuItems';
import ProfileMenuHelpItemss from './ProfileMenuHelpItems';
import UserSettings from './UserSettings';
import Purchases from './Pruchases';
import Bookings from './Bookings';
import PrivacyPolicy from './PrivacyPolicy';
import TermsConditions from './TermsConditions';
import RefundReason from './Bookings/RefundFlow/RefundReason';
import RefundConfirm from './Bookings/RefundFlow/RefundConfirm';
import UploadImageBooking from './UploadImageBooking';
import SuccessBooking from './SuccessBooking';
import { processRefund } from 'sdk/hooks/payments/useProcessRefund';
import Favorites from './Favorites';
import supabase from 'sdk/api';

export enum Menu {
  PROFILE = 'Profile Menu',
  PURCHASES = 'Purchases',
  BOOKINGS = 'Bookings',
  SETTINGS = 'Settings',
  HELP_CENTER = 'Help Center',
  PRIVACY_POLICY = 'Privacy & Policy',
  TERMS_CONDITIONS = 'Terms & Conditions',
  REFUND_REASON = 'Refund Reason',
  REFUND_PHOTO = 'Refund Photo',
  REFUND_CONFIRM = 'Refund Confirm',
  REFUND_COMPLETE = 'Refund Complete',
  FAVORITES = 'Favorites',
}

const ProfileMenu = () => {
  const [profileMenu, setProfileMenu] = useState(Menu.PROFILE);
  const navigate = useNavigate();

  const [refundReasons, setRefundReasons] = useState<string>();
  const [mediaUrls, setMediaUrls] = useState<Record<string, string>>({});
  const [bookingId, setBookingId] = useState<string>('');
  const [price, setPrice] = useState<number>();
  const [refundLoading, setRefundLoading] = useState(false);
  const [recordId, setRecordId] = useState(null)

  useEffect(() => {
    const debugUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      console.log('DEBUG: Full User Object:', user);
      console.log('DEBUG: User Metadata:', user?.user_metadata);
    };
    debugUser();
  }, []);

  return (
    <div className={clsx(styles.menu)}>
      {profileMenu === Menu.PROFILE && (
        <>
          <div className={styles.menu__inner}>
            <ProfileMenuHeader text={'Profile Menu'} onClose={() => navigate('/')} />
            <ProfileMenuButton />
            <ProfileMenuItems setProfileMenu={setProfileMenu} />
          </div>
          <div
            style={{
              width: '100%',
              height: '1px',
              background: '#00000033',
            }}
          />
          <div className={styles.menu__inner}>
            <ProfileMenuHelpItemss setProfileMenu={setProfileMenu} />
          </div>
        </>
      )}
      {/* {profileMenu === Menu.PURCHASES && <Purchases/>} */}
      {profileMenu === Menu.BOOKINGS && (
        <Bookings
          onClose={setProfileMenu}
          onRefund={booking => {
            setProfileMenu(Menu.REFUND_REASON);
            setBookingId(booking?.id);
            setPrice(booking?.price);
            setRecordId(booking?.record_id)
          }}
        />
      )}
      {profileMenu === Menu.REFUND_REASON && (
        <RefundReason
          onClose={() => setProfileMenu(Menu.BOOKINGS)}
          onNext={() => {
            setProfileMenu(Menu.REFUND_PHOTO);
          }}
          refundReason={refundReasons}
          setRefundReason={setRefundReasons}
        />
      )}
      {profileMenu === Menu.REFUND_PHOTO && (
        <UploadImageBooking
          mediaUrls={mediaUrls}
          setMediaUrls={setMediaUrls}
          onNext={() => {
            setProfileMenu(Menu.REFUND_CONFIRM);
          }}
          onBack={() => {
            setProfileMenu(Menu.REFUND_REASON);
          }}
        />
      )}

      {profileMenu === Menu.REFUND_CONFIRM && (
        <RefundConfirm
          onClose={() => setProfileMenu(Menu.REFUND_PHOTO)}
          onNext={async() => {
            setRefundLoading(true)
            try {
                await processRefund({ price, id: bookingId, refundReasons, mediaUrls, type: 'booking' });

                const { error } = await supabase.from('teams_availability').update({is_available: true, record_id: null}).eq('record_id', recordId)

                if (error) {
                  console.log('error whilte updating team availability', error)
                  return
                }

                setProfileMenu(Menu.REFUND_COMPLETE);
              } catch (err) {
                console.log(err);
              } finally {
                setRefundLoading(false)
              }
          }}
          refundLoading={refundLoading}
        />
      )}

      {profileMenu === Menu.REFUND_COMPLETE && <SuccessBooking onNext={() => setProfileMenu(Menu.PROFILE)} />}
      {profileMenu === Menu.SETTINGS && (
        <UserSettings onClose={setProfileMenu} closeAll={() => navigate(-1)} />
      )}
      {profileMenu === Menu.PRIVACY_POLICY && <PrivacyPolicy onClose={setProfileMenu} />}
      {profileMenu === Menu.TERMS_CONDITIONS && <TermsConditions onClose={setProfileMenu} />}
      {profileMenu === Menu.FAVORITES && <Favorites onClose={setProfileMenu} />}
    </div>
  );
};

export default ProfileMenu;
